export const ModuleConst = {
  Dashboard: 1,
  Users: 2,
  Coordinator: 3,
  Questionnaire: 4,
  Reporting: 5,
  SubAdmin: 6,
  Loan: 7,
  Analytics: 8,
  Cms: 9,
  Dispatcher: 10,
  Vendors: 11,
  Factory: 12,
  Geofence: 13,
  Booking: 14,
  Category: 15,
  Products: 16,
  ProductsAssign: 16.1,
  ProductsApprove: 16.2,
  Teams: 17,
  Pricing: 18,
  Tools: 19,
  Payments: 20,
  Discount: 21,
  Settings: 22,
  Logout: 23,
  Banners: 24,
  ChatSupport: 25,
  Review: 26,
  Driver: 27,
  Vehicle: 28,
  Brands: 29,
  SubCategory: 30,
  OrderManagement: 31,
  Orders: 31.1,
  Returns: 31.2,
  OrderEarnings: 32,
  SalesManager: 33,
  ManageArea: 33.1,
  PayloutManage: 34,
  DriverWallet: 35,
  Outlet: 36,
  PayoutManage: 37,
  DriverPayout: 37.1,
  FactoryRequests: 37.2,
  VendorPayout: 37.3,
  Notification: 38,
  Ratings: 39,
  Reports: 40,
  VendorReport: 40.1,
  ProductPerformanceReport: 40.2,
  CouponUsageReport: 40.3,
  FactoryReport: 40.4,
  EarningReport: 40.5,
  SalesSummaryReport: 40.6,
  TransactionSummaryReport: 40.7,
  SalesReport: 40.8,
  HomeSection: 41,
  AdvertisementPopup: 42,
  DiscountDeal: 43
};
